<template>
  <div class="px-3 py-1 pb-sm-0 pb-3 h-100 d-flex align-items-center">
    <ContentCard
      v-if="cycle.challenge_released"
      :status="status"
      theme="challenge"
      class="w-100"
    >
      <div v-if="cycle.is_finished">
        <CardEmptyContent :cycle="cycle" />
        <p>
          Você deveria ter concluído até {{ cycle.end_challenge_apply | moment('DD/MM/y') }}
        </p>
      </div>
      <div v-else>
        <CardEmptyContent :cycle="cycle" />
        <button
          class="bg-transparent border-0 px-0"
          @click="accessChallenge({cycle_config_id: cycle.id})"
        >
          <span class="align-middle">Acessar</span>
          <i class="fa fa-arrow-right align-middle" />
        </button>
      </div>
    </ContentCard>
    <ContentCard
      v-else
      theme="challenge"
      status="disabled"
      class="w-100"
    >
      <div v-if="cycle.modules.length">
        <CardEmptyContent :cycle="cycle" />
      </div>
      <p v-else>
        Ainda não há desafio disponível aqui.
      </p>
    </ContentCard>
  </div>
</template>
<script>

import CardEmptyContent from "../CardEmptyContent";
import ContentCard from "@/common/components/ContentCard";
import { mapActions } from 'vuex';

export default {
  components: {
    CardEmptyContent,
    ContentCard,
  },
  props: {
    cycle: {
      type: Object,
      required: true
    },
  },
  computed:{
    status(){
      return this.cycle.is_finished || !this.cycle.challenge_released ? 'disabled' : 'not-completed'
    },
  },  
  methods:{
    ...mapActions(['accessChallenge']),
  },
  }
</script>
